export default {
  sm: `
  LEED certification
  `
};
